import { Routes } from '@angular/router';
import { APP_CONSTANTS } from './app.constants';

export const routes: Routes = [
  {
    path: APP_CONSTANTS.ROUTE_PATHS.TERMS_CONDITION,
    loadComponent: () =>
      import('./pages/terms-and-conditions/terms-and-conditions.page').then(
        (m) => m.TermsAndConditionsPage
      ),
  },
  {
    path: APP_CONSTANTS.ROUTE_PATHS.HOME,
    loadComponent: () =>
      import('./pages/home/home.page').then((m) => m.HomePage),
  },
  {
    path: APP_CONSTANTS.ROUTE_PATHS.PRODUCT_CONTENT,
    loadComponent: () =>
      import('./pages/product-content/product-content.page').then(
        (m) => m.ProductContentPage
      ),
  },
  {
    path: APP_CONSTANTS.ROUTE_PATHS.SITEMAP,
    loadComponent: () =>
      import('./pages/sitemap/sitemap.page').then(
        (m) => m.SitemapPage
      ),
  },
  {
    path: 'sitemap.xml',
    loadComponent: () =>
      import('./pages/xml-sitemap/xml-sitemap.component').then(
        (m) => m.XmlSitemapComponent
      ),
  },
  {
    path: '',
    redirectTo: APP_CONSTANTS.ROUTE_PATHS.HOME,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: APP_CONSTANTS.ROUTE_PATHS.HOME,
  }
];
